import { __assign, __awaiter, __generator } from "tslib";
import { bootstrapFeature, initialize, preloadFeature, } from '@ms/centro-hvc-loader';
import { mergeObjects } from '@ms/ocv-inapp-feedback-shared';
import { CentroDataSourcesString, OcvInAppFeedback } from './Constants';
import { logError as logErrorInternal, logInfo as logInfoInternal } from './Logging';
import { getCentroParams, setInitTelemetryData, validateInitializationParameters } from './SupportFunctions';
var InAppFeedbackInitOptionsListener = (function () {
    var feedbackData = {};
    // register listener to Centro to enable dynamic data passing
    var register = function (listener) {
        if (listener) {
            listeners.push(listener);
        }
        return feedbackData;
    };
    // unregister listener from Centro
    var unregister = function (listener) {
        var index = listeners.indexOf(listener);
        if (index > -1) {
            listeners.splice(index, 1);
        }
    };
    // list of function provided to update Feedback configuration
    var listeners = [];
    /**
     *  Updates existing properties of the current instance
     */
    var updateFeedbackObject = function (updatedInAppFeedbackInitOptions) {
        var updatedFeedbackData = mergeObjects({}, feedbackData, updatedInAppFeedbackInitOptions);
        updatedFeedbackData = setInitTelemetryData(updatedFeedbackData);
        listeners.forEach(function (listener) { return listener(updatedFeedbackData); });
    };
    /**
     * Opens new feedback discarding old values
     */
    var openFeedbackObject = function (initFeedbackData) {
        initFeedbackData.feedbackConfig.isDisplayed = true;
        initFeedbackData = setInitTelemetryData(initFeedbackData);
        listeners.forEach(function (listener) { return listener(initFeedbackData); });
    };
    var configObject = {
        register: register,
        unregister: unregister,
        updateFeedbackObject: updateFeedbackObject,
        openFeedbackObject: openFeedbackObject,
    };
    return configObject;
})();
/**
 * Asynchronously launches the feedback mechanism within the application.
 *
 * This function initializes the feedback system with the provided initialization information
 * and in-app feedback options. It is designed to be called when the application
 * needs to trigger the feedback UI, allowing users to submit their feedback based on the
 * current state and configuration of the application.
 *
 * @param initializationInfo - Contains essential data required to initialize the feedback CDN.
 * @param inAppFeedbackInitOptions - Provides options to customize the in-app feedback experience.
 */
var launchFeedback = function (initializationInfo, inAppFeedbackInitOptions) { return __awaiter(void 0, void 0, void 0, function () {
    var bootstrapper, _a, e_1;
    var _b, _c, _d, _e, _f, _g, _h, _j;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                inAppFeedbackInitOptions.performanceTimestamps = __assign(__assign({}, inAppFeedbackInitOptions.performanceTimestamps), { integrationInitTimestamp: Date.now(), useCentroConfig: initializationInfo.useCentroConfig, isPrefetched: (_b = window.__inappfeedback_centro_integration_config) === null || _b === void 0 ? void 0 : _b.isPrefetched });
                return [4 /*yield*/, validateInitializationParameters(initializationInfo)];
            case 1:
                _k.sent();
                setupGlobalIntegrationConfig();
                if ((_c = window.__inappfeedback_centro_integration_config) === null || _c === void 0 ? void 0 : _c.unmountFunction) {
                    window.__inappfeedback_centro_integration_config.unmountFunction();
                }
                return [4 /*yield*/, window.__inappfeedback_centro_integration_config.loadInAppFeedbackPackage(initializationInfo, inAppFeedbackInitOptions === null || inAppFeedbackInitOptions === void 0 ? void 0 : inAppFeedbackInitOptions.clientFeedbackId)];
            case 2:
                _k.sent();
                _k.label = 3;
            case 3:
                _k.trys.push([3, 6, , 7]);
                logInfoInternal("532392" /* LoggingTags.FeedbackInitiated */, 'DOM Bootstrap Started.', {
                    clientFeedbackId: (_d = inAppFeedbackInitOptions === null || inAppFeedbackInitOptions === void 0 ? void 0 : inAppFeedbackInitOptions.clientFeedbackId) !== null && _d !== void 0 ? _d : null,
                    isPrefetched: (_e = window.__inappfeedback_centro_integration_config) === null || _e === void 0 ? void 0 : _e.isPrefetched,
                });
                return [4 /*yield*/, window.__inappfeedback_centro_integration_config.bootstrapFeature({
                        featureName: OcvInAppFeedback,
                    })
                    // Mounting the HVC on the provided HTML element
                ];
            case 4:
                bootstrapper = _k.sent();
                // Mounting the HVC on the provided HTML element
                _a = window.__inappfeedback_centro_integration_config;
                return [4 /*yield*/, bootstrapper.main(initializationInfo.inAppFeedbackRef)];
            case 5:
                // Mounting the HVC on the provided HTML element
                _a.unmountFunction = _k.sent();
                logInfoInternal("532392" /* LoggingTags.FeedbackInitiated */, 'DOM Bootstrap Completed.');
                return [3 /*break*/, 7];
            case 6:
                e_1 = _k.sent();
                logErrorInternal("532385" /* LoggingTags.CentroBootstrapFailed */, "Centro DOM bootstrap failed", e_1, {
                    hostName: initializationInfo.hostName,
                    locale: initializationInfo.locale,
                    inAppFeedbackRefAvailable: initializationInfo.inAppFeedbackRef ? true : false,
                    specificHvcVersion: (_f = initializationInfo.specificHvcVersion) !== null && _f !== void 0 ? _f : null,
                    majorVersion: (_g = initializationInfo.majorVersion) !== null && _g !== void 0 ? _g : null,
                    centroUrl: (_h = initializationInfo.centroUrl) !== null && _h !== void 0 ? _h : null,
                });
                return [3 /*break*/, 7];
            case 7:
                logInfoInternal("532386" /* LoggingTags.FeedbackComponentInitializationCompleted */, 'InAppFeedback Component Initialization Completed.');
                (_j = window.__inappfeedback_centro_integration_config) === null || _j === void 0 ? void 0 : _j.openFeedback(inAppFeedbackInitOptions);
                return [2 /*return*/];
        }
    });
}); };
/**
 * @deprecated - Do not use this function. Use launchFeedback instead.
 * This is function you call from hostapp, please wrap this in a try catch block
 *
 * Details of the data objects and functions can be found here
 * https://projectcentro.azurewebsites.net/docs/#/consume/adapter
 */
function initializeInAppFeedback(initializationInfo) {
    return __awaiter(this, void 0, void 0, function () {
        var bootstrapper, _a, e_2;
        var _b, _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0: return [4 /*yield*/, validateInitializationParameters(initializationInfo)];
                case 1:
                    _f.sent();
                    setupGlobalIntegrationConfig();
                    if ((_b = window.__inappfeedback_centro_integration_config) === null || _b === void 0 ? void 0 : _b.unmountFunction) {
                        window.__inappfeedback_centro_integration_config.unmountFunction();
                    }
                    return [4 /*yield*/, window.__inappfeedback_centro_integration_config.loadInAppFeedbackPackage(initializationInfo)];
                case 2:
                    _f.sent();
                    _f.label = 3;
                case 3:
                    _f.trys.push([3, 6, , 7]);
                    logInfoInternal("532392" /* LoggingTags.FeedbackInitiated */, 'DOM Bootstrap Started.');
                    return [4 /*yield*/, window.__inappfeedback_centro_integration_config.bootstrapFeature({
                            featureName: OcvInAppFeedback,
                        })
                        // Mounting the HVC on the provided HTML element
                    ];
                case 4:
                    bootstrapper = _f.sent();
                    // Mounting the HVC on the provided HTML element
                    _a = window.__inappfeedback_centro_integration_config;
                    return [4 /*yield*/, bootstrapper.main(initializationInfo.inAppFeedbackRef)];
                case 5:
                    // Mounting the HVC on the provided HTML element
                    _a.unmountFunction = _f.sent();
                    logInfoInternal("532392" /* LoggingTags.FeedbackInitiated */, 'DOM Bootstrap Completed.');
                    return [3 /*break*/, 7];
                case 6:
                    e_2 = _f.sent();
                    logErrorInternal("532385" /* LoggingTags.CentroBootstrapFailed */, "Centro DOM bootstrap failed", e_2, {
                        hostName: initializationInfo.hostName,
                        locale: initializationInfo.locale,
                        inAppFeedbackRefAvailable: initializationInfo.inAppFeedbackRef ? true : false,
                        specificHvcVersion: (_c = initializationInfo.specificHvcVersion) !== null && _c !== void 0 ? _c : null,
                        majorVersion: (_d = initializationInfo.majorVersion) !== null && _d !== void 0 ? _d : null,
                        centroUrl: (_e = initializationInfo.centroUrl) !== null && _e !== void 0 ? _e : null,
                    });
                    return [3 /*break*/, 7];
                case 7:
                    logInfoInternal("532386" /* LoggingTags.FeedbackComponentInitializationCompleted */, 'InAppFeedback Component Initialization Completed.');
                    return [2 /*return*/];
            }
        });
    });
}
function loadInAppFeedbackPackage(initializationInfo, clientFeedbackId) {
    return __awaiter(this, void 0, void 0, function () {
        var dataSources, centroAdapter, preloadParameter;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, initialize(getCentroParams(initializationInfo)).catch(function (e) {
                        var _a, _b, _c;
                        logErrorInternal("532383" /* LoggingTags.CentroInitializeFailed */, "Centro initialize failed", e, {
                            hostName: initializationInfo.hostName,
                            locale: initializationInfo.locale,
                            inAppFeedbackRefAvailable: initializationInfo.inAppFeedbackRef ? true : false,
                            specificHvcVersion: (_a = initializationInfo.specificHvcVersion) !== null && _a !== void 0 ? _a : null,
                            majorVersion: (_b = initializationInfo.majorVersion) !== null && _b !== void 0 ? _b : null,
                            centroUrl: (_c = initializationInfo.centroUrl) !== null && _c !== void 0 ? _c : null,
                        });
                    })];
                case 1:
                    _c.sent();
                    logInfoInternal("532444" /* LoggingTags.CentroRuntimeInitializeCompleted */, 'Centro Runtime Initialization Completed.', {
                        clientFeedbackId: clientFeedbackId !== null && clientFeedbackId !== void 0 ? clientFeedbackId : null,
                        isPrefetched: (_b = (_a = window.__inappfeedback_centro_integration_config) === null || _a === void 0 ? void 0 : _a.isPrefetched) !== null && _b !== void 0 ? _b : false,
                    });
                    dataSources = function (sd) {
                        sd(CentroDataSourcesString, InAppFeedbackInitOptionsListener);
                    };
                    centroAdapter = {
                        dataSources: dataSources,
                    };
                    preloadParameter = { featureName: OcvInAppFeedback, adapters: centroAdapter };
                    logInfoInternal("532448" /* LoggingTags.CentroPreloadFeatureStarted */, 'Centro preloadFeature Started.');
                    return [4 /*yield*/, preloadFeature(preloadParameter).catch(function (e) {
                            var _a, _b, _c;
                            logErrorInternal("532384" /* LoggingTags.CentroPreloadFeatureFailed */, "centro preloadFeature failed", e, {
                                hostName: initializationInfo.hostName,
                                locale: initializationInfo.locale,
                                inAppFeedbackRefAvailable: initializationInfo.inAppFeedbackRef ? true : false,
                                specificHvcVersion: (_a = initializationInfo.specificHvcVersion) !== null && _a !== void 0 ? _a : null,
                                majorVersion: (_b = initializationInfo.majorVersion) !== null && _b !== void 0 ? _b : null,
                                centroUrl: (_c = initializationInfo.centroUrl) !== null && _c !== void 0 ? _c : null,
                            });
                        })];
                case 2:
                    _c.sent();
                    logInfoInternal("532449" /* LoggingTags.CentroPreloadFeatureCompleted */, 'Centro preloadFeature Completed.');
                    return [2 /*return*/];
            }
        });
    });
}
var setupGlobalIntegrationConfig = function () {
    if (!window.__inappfeedback_centro_integration_config) {
        window.__inappfeedback_centro_integration_config = {
            updateFeedbackOptions: InAppFeedbackInitOptionsListener.updateFeedbackObject,
            openFeedback: InAppFeedbackInitOptionsListener.openFeedbackObject,
            logInfo: logInfoInternal,
            logError: logErrorInternal,
            unmountFunction: function () { return undefined; },
            bootstrapFeature: bootstrapFeature,
            loadInAppFeedbackPackage: loadInAppFeedbackPackage,
            isPrefetched: false,
        };
    }
};
/**
 * Asynchronously preloads the in-app feedback package.
 *
 * This function is responsible for preloading necessary resources for the in-app feedback feature
 * based on the provided initialization information. It ensures that when the feedback feature is
 * triggered, it can be presented to the user with minimal delay, enhancing the user experience.
 *
 * Note: You would need to call launchFeedback to trigger the UI
 *
 * @param initializationInfo -  Contains essential data required to initialize the feedback CDN.
 */
function preloadInAppFeedbackPackage(initializationInfo) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setupGlobalIntegrationConfig();
                    window.__inappfeedback_centro_integration_config.isPrefetched = true;
                    return [4 /*yield*/, window.__inappfeedback_centro_integration_config.loadInAppFeedbackPackage(initializationInfo)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
/**
 * Use this function after you have invoked launchFeedback at least once.
 * This allows you to update the feedback options dynamically after the initial feedback launch.
 *
 * @param {IFeedbackInitOptions} updatedInAppFeedbackInitOptions - The updated feedback initialization options.
 */
var updateFeedbackOptions = function (updatedInAppFeedbackInitOptions) {
    var _a;
    if ((_a = window.__inappfeedback_centro_integration_config) === null || _a === void 0 ? void 0 : _a.updateFeedbackOptions) {
        window.__inappfeedback_centro_integration_config.updateFeedbackOptions(updatedInAppFeedbackInitOptions);
        return;
    }
    logErrorInternal("532388" /* LoggingTags.UpdateFeedbackOptionsUnavailable */, "updateFeedbackOptions not added to config", new Error(JSON.stringify(window.__inappfeedback_centro_integration_config)));
};
/**
 * @deprecated - Do not use this function. Use launchFeedback instead.
 * */
var openFeedback = function (updatedInAppFeedbackInitOptions) {
    var _a;
    if ((_a = window.__inappfeedback_centro_integration_config) === null || _a === void 0 ? void 0 : _a.openFeedback) {
        window.__inappfeedback_centro_integration_config.openFeedback(updatedInAppFeedbackInitOptions);
        return;
    }
    logErrorInternal("532389" /* LoggingTags.OpenFeedbackunavailable */, "openFeedback not added to config", new Error(JSON.stringify(window.__inappfeedback_centro_integration_config)));
};
var logInfo = function (id, text, data) {
    var _a;
    if ((_a = window.__inappfeedback_centro_integration_config) === null || _a === void 0 ? void 0 : _a.logInfo) {
        window.__inappfeedback_centro_integration_config.logInfo(id, text, data);
        return;
    }
    logErrorInternal("532380" /* LoggingTags.LogInfoUnavailable */, "logInfo not added to config", new Error(JSON.stringify(window.__inappfeedback_centro_integration_config)));
};
var logError = function (id, text, error, data) {
    var _a;
    if ((_a = window.__inappfeedback_centro_integration_config) === null || _a === void 0 ? void 0 : _a.logError) {
        window.__inappfeedback_centro_integration_config.logError(id, text, error, data);
        return;
    }
    logErrorInternal("532381" /* LoggingTags.LogErrorUnavailable */, "logError not added to config", new Error(JSON.stringify(window.__inappfeedback_centro_integration_config)));
};
var unmountFeedback = function () {
    var _a;
    if ((_a = window.__inappfeedback_centro_integration_config) === null || _a === void 0 ? void 0 : _a.unmountFunction) {
        window.__inappfeedback_centro_integration_config.unmountFunction();
        return;
    }
    logErrorInternal("532387" /* LoggingTags.UnmountFeedbackUnavailable */, "unmountFeedback not added to config", new Error(JSON.stringify(window.__inappfeedback_centro_integration_config)));
};
export { initializeInAppFeedback, logError, logInfo, openFeedback, preloadInAppFeedbackPackage, unmountFeedback, updateFeedbackOptions, launchFeedback, };
